  class MegaMenuImageController {
    constructor(rootElement) {
      this.rootElement = rootElement;
      this.menuHandle = rootElement.dataset.menuHandle;
      this.imageElement = rootElement.querySelector('.mega-menu-image__img');
      this.titleElement = rootElement.querySelector('.type_mn_mega_title');
      
      if (!this.menuHandle || !this.imageElement) return;

      const menuItemsInCurrentMenu = document.querySelectorAll(
        `[data-mega-menu-item][data-menu-handle="${this.menuHandle}"]`
      );

      const allRelatedMenuItems = new Set();
      menuItemsInCurrentMenu.forEach(menuItem => {
        const columnElement = menuItem.closest('.sub-column-item');
        if (!columnElement) return;

        const columnsWrapperElement = columnElement.parentElement;
        if (!columnsWrapperElement) return;
        
        const allColumnElements = columnsWrapperElement.querySelectorAll('.sub-column-item');
        allColumnElements.forEach(columnEl => {
          columnEl.querySelectorAll('[data-mega-menu-item]').forEach(linkElement => {
            allRelatedMenuItems.add(linkElement);
          });
        });
      });

      this.menuItems = Array.from(allRelatedMenuItems);

      if (!this.menuItems.length) return;

      this.defaultImageSrc = this.imageElement.getAttribute('src');
      this.currentImageSrc = this.defaultImageSrc;
      this.preloadedImagesCache = new Map();

      this.preloadImages();
      this.bindEventListeners();
    }

    clearActiveStateFromAllItems() {
      this.menuItems.forEach((menuItemElement) => {
        menuItemElement.classList.remove('active-menu-link');
      });
    }

    bindEventListeners() {
      this.menuItems.forEach(menuItem => {
        menuItem.addEventListener('mouseenter', () => {
          try {
            this.clearActiveStateFromAllItems();
            menuItem.classList.add('active-menu-link');
            
            this.updateImage(menuItem.dataset.imageUrl);
            this.updateTitle(menuItem.dataset.menuTitle);
          } catch (error) {
            console.error('[MegaMenuImageController] Error handling mouseenter:', error);
            this.resetToDefault();
          }
        });
      });

      this.imageElement.addEventListener('error', () => {
        try {
          console.warn('[MegaMenuImageController] Image failed to load, resetting to default');
          this.resetToDefault();
        } catch (error) {
          console.error('[MegaMenuImageController] Error handling image error:', error);
        }
      });
    }

    preloadImages() {
      this.menuItems.forEach(menuItem => {
        const imageUrl = menuItem.dataset.imageUrl;
        
        if (!imageUrl || this.preloadedImagesCache.has(imageUrl)) return;

        const preloadImageElement = new Image();
        preloadImageElement.src = imageUrl;

        preloadImageElement.onload = () => {
          this.preloadedImagesCache.set(imageUrl, true);
          console.debug(`[MegaMenuImageController] Preloaded image: ${imageUrl}`);
        };

        preloadImageElement.onerror = () => {
          console.warn(`[MegaMenuImageController] Failed to preload image: ${imageUrl}`);
        };
      });
    }

    updateImage(newImageSrc) {
      if (!newImageSrc || newImageSrc === this.currentImageSrc) return;
      
      try {
        this.imageElement.src = newImageSrc;
        this.currentImageSrc = newImageSrc;
      } catch (error) {
        console.error('[MegaMenuImageController] Error updating image:', error);
        this.resetToDefault();
      }
    }

    updateTitle(newTitle) {
      if (!this.titleElement || !newTitle) return;
      
      try {
        this.titleElement.textContent = newTitle;
      } catch (error) {
        console.error('[MegaMenuImageController] Error updating title:', error);
      }
    }

    resetToDefault() {
      try {
        this.imageElement.src = this.defaultImageSrc;
        this.currentImageSrc = this.defaultImageSrc;
      } catch (error) {
        console.error('[MegaMenuImageController] Error resetting to default:', error);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    try {
      const megaMenuElements = document.querySelectorAll('[data-mega-menu-image]');
      megaMenuElements.forEach(element => {
        new MegaMenuImageController(element);
      });
    } catch (error) {
      console.error('[MegaMenuImageController] Initialization error:', error);
    }
  });